import { useEffect, useState } from 'react'
import { Label } from '@klear/ui/components/label'
import { Modal } from '@klear/ui/components/modal'
import { Textarea } from '@klear/ui/components/textarea'

export type RejectModalProps = {
  open: boolean
  title?: string
  isPending: boolean
  onOpenChange: (open: boolean) => void
  onReject: (input: { reason: string }) => void
}

export function RejectModal({
  open,
  title = 'Reject this review',
  isPending,
  onOpenChange,
  onReject
}: RejectModalProps) {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (open) setReason('')
  }, [open])

  const close = () => {
    if (isPending) return
    onOpenChange(false)
  }

  return (
    <Modal
      size="sm"
      open={open}
      onOpenChange={(next) => {
        if (!next) close()
      }}
      title={title}
      description="Nothing is created. The document moves to the Dismissed tab."
      primaryText={isPending ? 'Rejecting…' : 'Reject'}
      primaryDisabled={reason.trim() === '' || isPending}
      handlePrimaryAction={() => onReject({ reason: reason.trim() })}
      secondaryText="Cancel"
      secondaryDisabled={isPending}
      handleSecondaryAction={close}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Label htmlFor="reject-reason">Why (required)</Label>
          <Textarea
            id="reject-reason"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            maxLength={2000}
            rows={4}
            placeholder="What the next person needs to know"
            disabled={isPending}
          />
        </div>
      </div>
    </Modal>
  )
}
